// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h5[data-v-1a67e94d]{font-weight:700}.confirmation-content[data-v-1a67e94d]{display:flex;align-items:center;justify-content:center}.password-detected-message[data-v-1a67e94d]{margin-top:10px;color:green;display:flex;align-items:center}.password-detected-message i[data-v-1a67e94d]{margin-right:5px}", ""]);
// Exports
module.exports = exports;
